import { useEffect, useState } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { Col } from "reactstrap";

const TextFieldNew = ({
  input,
  label,
  meta: { touched, error },
  type,
  disabled,
  textBlur,
  placeholder,
  clearField,
  textChange,
}: any) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const [value, setValue] = useState(input?.value);

  useEffect(() => {
    setValue(input?.value);
  }, [input?.value]);

  useEffect(() => {
    if (clearField) {
      setValue(placeholder);
    } else {
      setValue(input?.value);
    }
  }, [clearField, input, placeholder]);

  return (
    <FormGroup row className="mb-3">
      <Label>{label}</Label>
      <Col sm={12} className="mr-2">
        <Input
          type={type}
          {...input}
          disabled={disabled}
          onChange={(event: any) => {
            if (textChange) textChange(event);
            input.onChange(event);
            setValue(event?.target?.value);
          }}
          onBlur={(event: any) => {
            if (textBlur) textBlur(event);
            input.onBlur(event);
          }}
          placeholder={placeholder}
          value={value}
        />
        <h6 className="danger">
          {touched && error && <span className="errorValidation">{error}</span>}
        </h6>
      </Col>
    </FormGroup>
  );
};

export default TextFieldNew;
